import type {FC} from 'react';

import type {Props} from './types';

import {AvatarPlaceholder} from '../../../../../uikit/AvatarPlaceholder';
import * as S from '../styles';

export const DMChannelsListItemJSX: FC<Props> = ({avatarUrl, title}) => {
  return (
    <S.Container>
      <S.AvatarImage
        placeholder={<AvatarPlaceholder text={title} />}
        src={avatarUrl ?? ''}
      />
      <S.Title>{title}</S.Title>
    </S.Container>
  );
};
